import { ALERT_STATUS } from '../constants/constants'

export const getSeverityColor = (severity?: string): string => {
    if (!severity) return 'inherit'
    const value = severity.toLowerCase()
    if (value.includes('critical')) return '#DC0202'
    if (value.includes('warning')) return '#B38A04'
    return 'inherit'
}

export const stripTimeFromMessage = (message?: string): string => {
    if (!message) return ''
    return message
        .replace(/\s+(on|at)\s+\d{1,2}\/\d{1,2}\/\d{4}.*$/i, '')
        .trim()
}

/**
 * UBQ-5487: the artwork already matched the renamed states — the badge that was filed under `_read`
 * draws a **checkmark** (Acknowledged) and `_ignore` draws a **dash** (Ignored). Only the filenames
 * were wrong, so the four `*_read.svg` were renamed to `*_acknowledged.svg`; no artwork changed.
 * Before the rename these were inverted: status 2 read as "Acknowledge" while rendering a dash.
 */
export const getStatusIconPath = (
    status: number,
    severity?: string,
): string => {
    let suffix = 'unread'
    if (status === ALERT_STATUS.ACKNOWLEDGED) suffix = 'acknowledged'
    if (status === ALERT_STATUS.IGNORED) suffix = 'ignore'

    let prefix = 'normal'
    const sevLower = severity?.toLowerCase() || ''
    if (sevLower.includes('critical')) prefix = 'critical'
    else if (sevLower.includes('warning')) prefix = 'warning'
    else if (sevLower.includes('info')) prefix = 'info'

    return `/assets/images/icons/notification_status/${prefix}_${suffix}.svg`
}

export const getStatusTooltipText = (
    status: number,
    severity?: string,
    t: (key: string) => string = (s: string) => s,
): string => {
    let cleanSeverity = 'Normal'
    const sevLower = severity?.toLowerCase() || ''
    if (sevLower.includes('critical')) cleanSeverity = t('critical')
    else if (sevLower.includes('warning')) cleanSeverity = t('warning')
    else if (sevLower.includes('info')) cleanSeverity = t('info')
    else cleanSeverity = t('Normal')

    /* States, not actions: this describes what the icon currently shows ("Critical Acknowledged"),
       so it uses the past participle rather than the "Mark as ..." wording of the menu items. */
    if (status === ALERT_STATUS.ACKNOWLEDGED)
        return `${cleanSeverity} ${t('Acknowledged')}`
    if (status === ALERT_STATUS.IGNORED)
        return `${cleanSeverity} ${t('Ignored')}`
    return cleanSeverity
}
